export default function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-background-200">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(255,151,60,0.16),transparent_55%),radial-gradient(ellipse_at_bottom_right,rgba(214,49,53,0.14),transparent_60%)]"
        aria-hidden="true"
      ></div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-10 lg:grid-cols-[1.15fr_0.85fr] items-center px-4 md:px-6 py-12 md:py-20 lg:py-24">
        <div className="rise-in">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-900">
            <i className="ri-flashlight-fill text-accent-700"></i>
            92爆料 · 线索投稿社区
          </span>

          <h2 className="mt-6 font-heading text-4xl font-black leading-[1.15] text-foreground-950 sm:text-5xl lg:text-6xl">
            现场先到，
            <br />
            真相你来
            <span className="text-primary-600">定夺。</span>
          </h2>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            一个把一手材料、私信线索与吃瓜讨论放上同一张桌子的社区。有瓜可发、有料可报，直接联系入口就在下方——
            <strong className="font-semibold text-foreground-950">关注即可对接，不迷路。</strong>
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#entrance"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-7 py-3 text-base font-semibold text-background-50 hover:bg-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-fill text-lg"></i>
              私信投线索
            </a>
            <a
              href="#follow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 bg-background-50 px-7 py-3 text-base font-semibold text-foreground-900 hover:border-accent-500 hover:text-accent-700 transition-colors cursor-pointer"
            >
              <i className="ri-user-follow-line text-lg"></i>
              关注对接
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5"><i className="ri-shield-check-line text-primary-500"></i> 匿名昵称自选</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-eye-off-line text-primary-500"></i> 私信默认打码</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-fire-line text-accent-600"></i> 热榜每 10 分钟刷新</span>
          </div>
        </div>

        <div className="rise-in relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20layered%20with%20candid%20newspaper%20clippings%20phone%20chat%20bubbles%20polaroid%20prints%20and%20night%20city%20street%20lights%20over%20warm%20cream%20paper%2C%20deep%20red%20and%20amber%20tones%20dominate%2C%20modern%20press%20art%20aesthetic%2C%20soft%20shadows%2C%20rich%20texture%2C%20cohesive%20and%20tasteful%20composition&width=820&height=980&seq=hero-collage-v1&orientation=portrait"
              alt="92爆料 线索素材编辑拼贴"
              className="h-[420px] w-full object-cover md:h-[520px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>

            <div className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-600/95 px-3 py-1.5 text-xs font-bold text-background-50">
              <i className="ri-fire-fill text-accent-200"></i> 热门围观中
            </div>

            <div className="absolute bottom-4 left-4 right-4 rounded-xl border border-background-50/40 bg-background-50/85 p-4 backdrop-blur-sm">
              <p className="text-sm font-semibold text-foreground-950">一张现场拼贴里，藏着今晚最好聊的料。</p>
              <p className="mt-1 text-xs text-foreground-600">把散落的线索拼成一张可讨论的图，这就是 92爆料 干的事。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}